import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useMemo, useState, useRef } from 'react';
import useSendbirdStateContext from '../../useSendbirdStateContext.js';
import { u as useLocalization } from '../../LocalizationContext-a82461b5.js';
import { g as getChannelTitle } from '../../utils-b571dc44.js';
import { u as useThreadContext, i as isAboutSame } from '../../ThreadProvider-cf357120.js';
import ParentMessageInfo from './ParentMessageInfo.js';
import ThreadHeader from './ThreadHeader.js';
import ThreadList from './ThreadList.js';
import ThreadMessageInput from './ThreadMessageInput.js';
import { ParentMessageStateTypes, ThreadListStateTypes } from '../context/types.js';
import { P as PlaceHolder, a as PlaceHolderTypes } from '../../index-2cfab646.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../../index-6420013c.js';
import { MessageProvider } from '../../Message/context.js';
import '../../withSendbird.js';
import '../../_rollupPluginBabelHelpers-05128ded.js';
import '../../stringSet-b60e9529.js';
import '../../index-6add7940.js';
import '../../index-ccef08fe.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../UserProfileContext-f3f446d2.js';
import 'prop-types';
import '@sendbird/chat';
import '../../topics-eb548880.js';
import '@sendbird/chat/groupChannel';
import '../../uuid-717930b4.js';
import '@sendbird/chat/message';
import '../../consts-fa6ab3c0.js';
import '../../RemoveMessageModal-2adc29ce.js';
import '../../ui/Modal.js';
import 'react-dom';
import '../../index-a9101009.js';
import '../../ui/Button.js';
import '../../ui/Icon.js';
import '../../ui/IconButton.js';
import '../../MediaQueryContext-d6110905.js';
import './ParentMessageInfoItem.js';
import '../../index-579ca9d7.js';
import '../../ui/ImageRenderer.js';
import '../../ui/TextButton.js';
import '../../color-91e43dce.js';
import '../../ui/EmojiReactions.js';
import '../../ui/ReactionBadge.js';
import '../../ui/ReactionButton.js';
import '../../useLongPress-12280c78.js';
import '../../utils-e0c7329c.js';
import '../../ui/ContextMenu.js';
import '../../ui/SortByRow.js';
import '../../ui/BottomSheet.js';
import '../../ui/UserListItem.js';
import '../../ui/Avatar.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../sendbirdSelectors.js';
import '../../ui/Tooltip.js';
import '../../ui/TooltipWrapper.js';
import '../../ui/VoiceMessageItemBody.js';
import '../../ui/ProgressBar.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../index-fa5b2b8c.js';
import '../../VoiceRecorder/context.js';
import '../../ui/PlaybackTime.js';
import '../../ui/Loader.js';
import '../../index-a2bb2783.js';
import '../../index.module-4f1cd64e.js';
import '../../tokenize-c718324d.js';
import '../../ui/MentionLabel.js';
import '../../ui/LinkLabel.js';
import '../../ChannelProvider-5dcbee7b.js';
import '../../const-72f012b6.js';
import '../../compareIds-2e50e905.js';
import '../../resolvedReplyType-9d00a3db.js';
import '../../Channel/components/SuggestedMentionList.js';
import '../../const-3a34a127.js';
import '../../ui/FileViewer.js';
import '../../ui/MessageItemMenu.js';
import '../../types-95cfd227.js';
import '../../ui/MessageItemReactionMenu.js';
import '../../ui/MessageInput.js';
import 'dompurify';
import '../../consts-b4cb83cf.js';
import '../../consts-7693b8d3.js';
import '../../consts-9469111b.js';
import '../../index-86294a68.js';
import '../../useDirtyGetMentions-dffd4046.js';
import './ThreadListItem.js';
import '../../ui/DateSeparator.js';
import '../../index-ac0b2d20.js';
import '../../index-f879f6ef.js';
import '../../index-ad50e2c0.js';
import '../../ui/TextMessageItemBody.js';
import '../../ui/OGMessageItemBody.js';
import '../../ui/FileMessageItemBody.js';
import '../../ui/ThumbnailMessageItemBody.js';
import '../../ui/UnknownMessageItemBody.js';
import 'date-fns';
import '../../VoiceMessageInputWrapper-43163d7f.js';
import '../../VoiceRecorder/useVoiceRecorder.js';
import '../../index-090cbf21.js';
var useMemorizedHeader = function useMemorizedHeader(_ref) {
  var renderHeader = _ref.renderHeader;
  return useMemo(function () {
    if (typeof renderHeader === 'function') {
      return renderHeader();
    }
    return null;
  }, [renderHeader]);
};
var useMemorizedParentMessageInfo = function useMemorizedParentMessageInfo(_ref) {
  var parentMessage = _ref.parentMessage,
    parentMessageState = _ref.parentMessageState,
    renderParentMessageInfo = _ref.renderParentMessageInfo,
    renderParentMessageInfoPlaceholder = _ref.renderParentMessageInfoPlaceholder;
  return useMemo(function () {
    if (parentMessageState === ParentMessageStateTypes.NIL || parentMessageState === ParentMessageStateTypes.LOADING || parentMessageState === ParentMessageStateTypes.INVALID) {
      if (typeof renderParentMessageInfoPlaceholder === 'function') {
        return renderParentMessageInfoPlaceholder(parentMessageState);
      }
      switch (parentMessageState) {
        case ParentMessageStateTypes.NIL:
          {
            return /*#__PURE__*/React__default.createElement(PlaceHolder, {
              className: "sendbird-thread-ui__parent-message-info placeholder-nil",
              type: PlaceHolderTypes.NO_RESULTS,
              iconSize: "64px"
            });
          }
        case ParentMessageStateTypes.LOADING:
          {
            return /*#__PURE__*/React__default.createElement(PlaceHolder, {
              className: "sendbird-thread-ui__parent-message-info placeholder-loading",
              type: PlaceHolderTypes.LOADING,
              iconSize: "64px"
            });
          }
        case ParentMessageStateTypes.INVALID:
          {
            return /*#__PURE__*/React__default.createElement(PlaceHolder, {
              className: "sendbird-thread-ui__parent-message-info placeholder-invalid",
              type: PlaceHolderTypes.WRONG,
              iconSize: "64px"
            });
          }
        default:
          {
            return null;
          }
      }
    } else if (parentMessageState === ParentMessageStateTypes.INITIALIZED) {
      if (typeof renderParentMessageInfo === 'function') {
        return renderParentMessageInfo();
      }
    }
    return null;
  }, [parentMessage, parentMessageState, renderParentMessageInfo, renderParentMessageInfoPlaceholder]);
};
var useMemorizedThreadList = function useMemorizedThreadList(_ref) {
  var threadListState = _ref.threadListState,
    renderThreadListPlaceHolder = _ref.renderThreadListPlaceHolder;
  return useMemo(function () {
    if (threadListState === ThreadListStateTypes.NIL || threadListState === ThreadListStateTypes.LOADING || threadListState === ThreadListStateTypes.INVALID) {
      if (typeof renderThreadListPlaceHolder === 'function') {
        return renderThreadListPlaceHolder(threadListState);
      }
      switch (threadListState) {
        case ThreadListStateTypes.LOADING:
          {
            return /*#__PURE__*/React__default.createElement(PlaceHolder, {
              className: "sendbird-thread-ui__thread-list placeholder-loading",
              type: PlaceHolderTypes.LOADING,
              iconSize: "64px"
            });
          }
        case ThreadListStateTypes.INVALID:
          {
            return /*#__PURE__*/React__default.createElement(PlaceHolder, {
              className: "sendbird-thread-ui__thread-list placeholder-invalid",
              type: PlaceHolderTypes.WRONG,
              iconSize: "64px"
            });
          }
        case ThreadListStateTypes.NIL:
          {
            return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
          }
        default:
          {
            return null;
          }
      }
    }
    return null;
  }, [threadListState, renderThreadListPlaceHolder]);
};
var ThreadUI = function ThreadUI(_ref) {
  var _stores$sdkStore, _stores$sdkStore$sdk, _stores$sdkStore$sdk$, _parentMessage$sender;
  var renderHeader = _ref.renderHeader,
    renderParentMessageInfo = _ref.renderParentMessageInfo,
    renderMessage = _ref.renderMessage,
    renderMessageInput = _ref.renderMessageInput,
    renderCustomSeparator = _ref.renderCustomSeparator,
    renderParentMessageInfoPlaceholder = _ref.renderParentMessageInfoPlaceholder,
    renderThreadListPlaceHolder = _ref.renderThreadListPlaceHolder,
    renderFileUploadIcon = _ref.renderFileUploadIcon,
    renderVoiceMessageIcon = _ref.renderVoiceMessageIcon,
    renderSendMessageIcon = _ref.renderSendMessageIcon;
  var _useSendbirdStateCont = useSendbirdStateContext(),
    stores = _useSendbirdStateCont.stores;
  var currentUserId = stores === null || stores === void 0 ? void 0 : (_stores$sdkStore = stores.sdkStore) === null || _stores$sdkStore === void 0 ? void 0 : (_stores$sdkStore$sdk = _stores$sdkStore.sdk) === null || _stores$sdkStore$sdk === void 0 ? void 0 : (_stores$sdkStore$sdk$ = _stores$sdkStore$sdk.currentUser) === null || _stores$sdkStore$sdk$ === void 0 ? void 0 : _stores$sdkStore$sdk$.userId;
  var _useLocalization = useLocalization(),
    stringSet = _useLocalization.stringSet;
  var _useThreadContext = useThreadContext(),
    currentChannel = _useThreadContext.currentChannel,
    allThreadMessages = _useThreadContext.allThreadMessages,
    parentMessage = _useThreadContext.parentMessage,
    parentMessageState = _useThreadContext.parentMessageState,
    threadListState = _useThreadContext.threadListState,
    hasMorePrev = _useThreadContext.hasMorePrev,
    hasMoreNext = _useThreadContext.hasMoreNext,
    fetchPrevThreads = _useThreadContext.fetchPrevThreads,
    fetchNextThreads = _useThreadContext.fetchNextThreads,
    onHeaderActionClick = _useThreadContext.onHeaderActionClick,
    onMoveToParentMessage = _useThreadContext.onMoveToParentMessage;
  var replyCount = allThreadMessages.length;
  var isByMe = currentUserId === (parentMessage === null || parentMessage === void 0 ? void 0 : (_parentMessage$sender = parentMessage.sender) === null || _parentMessage$sender === void 0 ? void 0 : _parentMessage$sender.userId);

  // Memoized custom components
  var MemorizedHeader = useMemorizedHeader({
    renderHeader: renderHeader
  });
  var MemorizedParentMessageInfo = useMemorizedParentMessageInfo({
    parentMessage: parentMessage,
    parentMessageState: parentMessageState,
    renderParentMessageInfo: renderParentMessageInfo,
    renderParentMessageInfoPlaceholder: renderParentMessageInfoPlaceholder // nil, loading, invalid
  });
  var MemorizedThreadList = useMemorizedThreadList({
    threadListState: threadListState,
    renderThreadListPlaceHolder: renderThreadListPlaceHolder
  });

  // scroll
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollBottom = _useState2[0],
    setScrollBottom = _useState2[1];
  var scrollRef = useRef(null);
  var onScroll = function onScroll(e) {
    var _scrollRef$current;
    var element = e.target;
    var scrollTop = element.scrollTop,
      clientHeight = element.clientHeight,
      scrollHeight = element.scrollHeight;
    var threadItemNodes = (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.querySelectorAll('.sendbird-thread-list-item');
    var firstNode = threadItemNodes === null || threadItemNodes === void 0 ? void 0 : threadItemNodes[0];
    if (isAboutSame(scrollTop, 0, 10) && hasMorePrev) {
      fetchPrevThreads(function (messages) {
        if (messages) {
          try {
            var _firstNode$scrollInto;
            firstNode === null || firstNode === void 0 ? void 0 : (_firstNode$scrollInto = firstNode.scrollIntoView) === null || _firstNode$scrollInto === void 0 ? void 0 : _firstNode$scrollInto.call(firstNode, {
              block: 'start',
              inline: 'nearest'
            });
          } catch (error) {
            //
          }
        }
      });
    }
    if (isAboutSame(clientHeight + scrollTop, scrollHeight, 10) && hasMoreNext) {
      var scrollTop_ = scrollTop;
      fetchNextThreads(function (messages) {
        if (messages) {
          try {
            element.scrollTop = scrollTop_;
            scrollRef.current.scrollTop = scrollTop_;
          } catch (error) {
            //
          }
        }
      });
    }

    // save the lastest scroll bottom value
    if (scrollRef !== null && scrollRef !== void 0 && scrollRef.current) {
      var current = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;
      setScrollBottom(current.scrollHeight - current.scrollTop - current.offsetHeight);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-thread-ui"
  }, MemorizedHeader || /*#__PURE__*/React__default.createElement(ThreadHeader, {
    className: "sendbird-thread-ui__header",
    channelName: getChannelTitle(currentChannel, currentUserId, stringSet),
    onActionIconClick: onHeaderActionClick,
    onChannelNameClick: function onChannelNameClick() {
      onMoveToParentMessage === null || onMoveToParentMessage === void 0 ? void 0 : onMoveToParentMessage({
        message: parentMessage,
        channel: currentChannel
      });
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-thread-ui--scroll",
    ref: scrollRef,
    onScroll: onScroll
  }, /*#__PURE__*/React__default.createElement(MessageProvider, {
    message: parentMessage,
    isByMe: isByMe
  }, MemorizedParentMessageInfo || /*#__PURE__*/React__default.createElement(ParentMessageInfo, {
    className: "sendbird-thread-ui__parent-message-info"
  })), replyCount > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-thread-ui__reply-counts"
  }, /*#__PURE__*/React__default.createElement(Label, {
    type: LabelTypography.BODY_1,
    color: LabelColors.ONBACKGROUND_3
  }, "".concat(replyCount, " ").concat(replyCount > 1 ? stringSet.THREAD__THREAD_REPLIES : stringSet.THREAD__THREAD_REPLY))), MemorizedThreadList || /*#__PURE__*/React__default.createElement(ThreadList, {
    className: "sendbird-thread-ui__thread-list",
    allThreadMessages: allThreadMessages,
    renderMessage: renderMessage,
    renderCustomSeparator: renderCustomSeparator,
    scrollRef: scrollRef,
    scrollBottom: scrollBottom
  })), (renderMessageInput === null || renderMessageInput === void 0 ? void 0 : renderMessageInput()) || /*#__PURE__*/React__default.createElement(ThreadMessageInput, {
    className: "sendbird-thread-ui__message-input",
    renderFileUploadIcon: renderFileUploadIcon,
    renderVoiceMessageIcon: renderVoiceMessageIcon,
    renderSendMessageIcon: renderSendMessageIcon
  }));
};
export { ThreadUI as default };